import { Button, ModalWrapper } from '@/shared';
import React from 'react';
import { useUpdateResidentStatus } from '../../hooks';

interface UnarchivedResidentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  resident: { id: string; name: string };
}

export const UnarchivedResidentModal: React.FC<
  UnarchivedResidentModalProps
> = ({ isOpen, onClose, onConfirm, resident }) => {
  const { mutate: updateResidentStatus, isPending } = useUpdateResidentStatus();
  const handleConfirmUnarchive = () => {
    updateResidentStatus({
      residentId: resident.id,
      status: 'ACTIVE',
    });
    onConfirm();
    onClose();
  };

  const handleCancleUnarcived = () => {
    onClose();
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-center w-full min-h-full">
        <div className="w-xl p-8 bg-white rounded-4xl">
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32 34C40.8366 34 48 26.8366 48 18C48 9.16344 40.8366 2 32 2C23.1634 2 16 9.16344 16 18C16 26.8366 23.1634 34 32 34Z"
              fill="#5761EB"
            />
            <path
              d="M10 62.0002H34.72C31.2082 59.1854 28.8826 55.1535 28.2046 50.7041C27.5267 46.2548 28.5459 41.7132 31.06 37.9802C25.8895 37.7233 21.0177 35.4809 17.46 31.7202C13.4718 33.4038 10.0681 36.2252 7.67424 39.8321C5.28034 43.4389 4.00237 47.6712 4 52.0002V56.0002C4.00475 57.5901 4.63841 59.1134 5.7626 60.2376C6.8868 61.3618 8.41016 61.9955 10 62.0002Z"
              fill="#5761EB"
            />
            <circle cx="46" cy="48" r="14" fill="#5761EB" />
            <path
              d="M46 53.3333L49.5556 49.7778L48.3111 48.5333L46.8889 49.9556V46.2222H45.1111V49.9556L43.6889 48.5333L42.4444 49.7778L46 53.3333ZM39.7778 44.4444V54.2222H52.2222V44.4444H39.7778ZM39.7778 56C39.2889 56 38.8704 55.8259 38.5222 55.4778C38.1741 55.1296 38 54.7111 38 54.2222V43.1333C38 42.9259 38.0333 42.7259 38.1 42.5333C38.1667 42.3407 38.2667 42.163 38.4 42L39.5111 40.6444C39.6741 40.437 39.8778 40.2778 40.1222 40.1667C40.3667 40.0556 40.6222 40 40.8889 40H51.1111C51.3778 40 51.6333 40.0556 51.8778 40.1667C52.1222 40.2778 52.3259 40.437 52.4889 40.6444L53.6 42C53.7333 42.163 53.8333 42.3407 53.9 42.5333C53.9667 42.7259 54 42.9259 54 43.1333V54.2222C54 54.7111 53.8259 55.1296 53.4778 55.4778C53.1296 55.8259 52.7111 56 52.2222 56H39.7778ZM40.1333 42.6667H51.8667L51.1111 41.7778H40.8889L40.1333 42.6667Z"
              fill="white"
            />
          </svg>

          <div className="my-4 md:my-8">
            <h4 className="text-xl md:text-3xl font-bold text-text-primary mb-2 ">
              Unarchieved resident ({resident.name})
            </h4>
            <p className="text-base md:text-xl text-text-secondary ">
              View and manage all active residents who are not archived. Track
              their status, payments, and house assignments in one place.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <button
              className="p-2 text-[#5761EB] text-base md:text-lg font-bold cursor-pointer rounded-md border border-[#ffffff] hover:border-[#5761EB] transition-colors duration-200"
              onClick={handleCancleUnarcived}
            >
              Cancle
            </button>
            <Button
              className="!text-base md:!text-lg !font-bold"
              onClick={handleConfirmUnarchive}
            >
              {isPending ? 'Loading...' : 'Unarchieve'}
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};
